import { Box, FormControlLabel } from "@mui/material";
import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
} from "@mui/material";
import {
  getWebAppSetting,
  updateWebAppSetting,
} from "../../apis/apisList/adminApi";
import { useEffect } from "react";

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "#65C466",
        opacity: 1,
        border: 0,
        ...theme.applyStyles("dark", {
          backgroundColor: "#2ECA45",
        }),
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color: theme.palette.grey[100],
      ...theme.applyStyles("dark", {
        color: theme.palette.grey[600],
      }),
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 0.7,
      ...theme.applyStyles("dark", {
        opacity: 0.3,
      }),
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: "#E9E9EA",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
    ...theme.applyStyles("dark", {
      backgroundColor: "#39393D",
    }),
  },
}));

const AdminSettings = () => {
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [dailogDetail, setDailogDetail] = useState({
    title: "Shut down WebApp Confirmation",
    desc: "Are you sure you want to shut down web app",
    btn_text: "Shut down",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  const handleChange = (state) => {
    setDeleteDialogOpen(true);
    if (!state) {
      setDailogDetail({
        title: "Re-enable WebApp Confirmation",
        desc: "Are you sure you want to turn the web app back on?",
        btn_text: "Turn back on",
      });
    }
  };

  const onClose = () => {
    setDeleteDialogOpen(false);
  };

  useEffect(() => {
    getWebAppSetting().then((res) => {
      setIsChecked(res?.data?.web_app_shut_down);
    });
  }, []);

  const handleOnCLick = () => {
    setIsLoading(true);
    updateWebAppSetting({ web_app_shut_down: !isChecked })
      .then((res) => {
        setIsChecked(res?.data?.web_app_shut_down);
        setDeleteDialogOpen(false);
      })
      .catch((err) => {
        console.error("Other error:", err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div>
      <Box
        className="passwordRowBox"
        sx={{
          maxWidth: "100%",
          margin: "0 auto",
          display: "flex",
          flexDirection: "column",
          gap: 3,
        }}
      >
        <Box className="">
          <FormControlLabel
            control={
              <IOSSwitch
                sx={{ m: 1 }}
                onChange={(e) => {
                  const checked = e.target.checked;
                  handleChange(checked);
                }}
                checked={isChecked}
              />
            }
            label="Shut down WebApp"
          />
        </Box>
      </Box>
      <Dialog
        open={deleteDialogOpen}
        onClose={() => {
          setDeleteDialogOpen(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{dailogDetail?.title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {dailogDetail?.desc}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            onClick={() => {
              handleOnCLick();
            }}
            color="error"
            variant="contained"
            disabled={isLoading}
            startIcon={
              isLoading ? <CircularProgress size={20} color="inherit" /> : null
            }
          >
            {isLoading ? "Updating..." : dailogDetail?.btn_text}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AdminSettings;
